import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { login } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import useStore from "../../useStore";

const validationSchema = Yup.object({
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  passcode: Yup.string().required("Required"),
});

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate(); // Hook to navigate to different routes
  const { setPermissions } = useStore();

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{
        backgroundColor: "#eee",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "15px",
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            sx={{
              color: "#000",
              m: "10px",
              textAlign: "center",
              letterSpacing: 1,
              fontWeight: 600,
            }}
          >
            <span style={{ color: "#5252ff" }}>HP</span> FINANCE
          </Typography>
          <Typography variant="h5" align="center" gutterBottom>
            Admin Login
          </Typography>
          <Typography
            variant="body2"
            align="center"
            color="textSecondary"
            gutterBottom
          >
            Hey, Enter your details to get sign in to your account
          </Typography>
          <Formik
            initialValues={{ phoneNumber: "", passcode: "" }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              setLoading(true);
              setError("");
              try {
                const { access_token, user, permissions } = await login(
                  values.phoneNumber,
                  values.passcode
                );
                // Store accessToken in sessionStorage
                sessionStorage.setItem("accessToken", access_token);
                setPermissions(permissions?.permissions);
                toast.success("Login successfull");
                // Navigate to the dashboard
                navigate("/dashboard");

                console.log("Logged in user:", user);
              } catch (err) {
                setError(err);
              } finally {
                setLoading(false);
                setSubmitting(false);
              }
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <Typography mt={2}>Phone Number</Typography>
                <Field
                  as={TextField}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  size="small"
                  name="phoneNumber"
                  sx={{ m: 0 }}
                  inputProps={{
                    maxLength: 10, // Limits the input to 10 characters
                  }}
                  error={touched.phoneNumber && !!errors.phoneNumber}
                  helperText={touched.phoneNumber && errors.phoneNumber}
                />
                <Typography mt={2}>Password</Typography>
                <Field
                  as={TextField}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="passcode"
                  size="small"
                  sx={{ m: 0 }}
                  type={showPassword ? "text" : "password"} // Toggle password visibility
                  error={touched.passcode && !!errors.passcode}
                  helperText={touched.passcode && errors.passcode}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{
                    marginTop: "20px",
                    backgroundColor: "#5252ff",
                    color: "#fff",
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} style={{ color: "#fff" }} />
                  ) : (
                    "Login"
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Login;
